const regions = [
  'New England(PADD 1A) No 2 Diesel Retail Prices, Weekly',
  'Central Atlantic(PADD 1B) No 2 Diesel Retail Prices, Weekly',
  'West Coast(PADD 5) Except California No 2 Diesel Retail Prices, Weekly',
  'East Coast No 2 Diesel Retail Prices, Weekly',
  'Rocky Mountain No 2 Diesel Retail Prices, Weekly',
  'Gulf Coast No 2 Diesel Retail Prices, Weekly',
  'U.S. No 2 Diesel Retail Prices, Weekly',
  'California No 2 Diesel Retail Prices, Weekly',
  'Midwest No 2 Diesel Retail Prices, Weekly',
  'West Coast No 2 Diesel Retail Prices, Weekly',
  'Lower Atlantic (PADD 1C) No 2 Diesel Retail Prices, Weekly',
];

const effectiveDays = [
  {
    label: 'Sunday',
    value: '0',
  },
  {
    label: 'Monday',
    value: '1',
  },
  {
    label: 'Tuesday',
    value: '2',
  },
  {
    label: 'Wednesday',
    value: '3',
  },
  {
    label: 'Thursday',
    value: '4',
  },
  {
    label: 'Friday',
    value: '5',
  },
  {
    label: 'Saturday',
    value: '6',
  },
];

const types = {
  LTL: 0,
  TL: 1,
};

const DefaultFuelSurchargeRange = {
  id: '00000000-0000-0000-0000-000000000000',
  max: 0,
  min: 0,
  surchargeModifier: 0,
  type: 0,
};

export const INITIAL_CARRIER_FUELSURCHARGE = {
  fuelSurchargeRanges: [],
  type: 1,
  isDeleted: null,
  isDefault: false,
  eiaRegion: '',
  effectiveDay: null,
  operationType: 'None',
};

export { regions, effectiveDays, types, DefaultFuelSurchargeRange };
